import { AppSwitcherLink } from '../types/navigation.types';

export const mapToStihlIdAppSwitcher = (item) => {
  const { id, icon, displayName, description, url, category, order, iconUrl, urlIos, urlAndroid } = item.fields;
  return {
    id,
    icon: icon || null,
    iconUrl: iconUrl || null,
    order: order || 0,
    displayName: displayName || null,
    description: description?.content[0]?.content[0]?.value || null,
    category,
    url: url || null,
    urlIos: urlIos || null,
    urlAndroid: urlAndroid || null,
  };
};

export const getInitials = (name: string) => {
  const names = name?.split(' ');

  if (!names) {
    return undefined;
  }

  if (names.length === 1) {
    return names[0]?.[0]?.toUpperCase();
  }

  return [names[0], names[names.length - 1]]
    ?.map((word) => word.charAt(0))
    ?.join('')
    ?.toUpperCase();
};

export const getCurrentPlatform = () => {
  const u = navigator.userAgent;
  const isAndroid = /Android/i.exec(u);
  const isIos = /iPad|iPhone|iPod/i.exec(u);

  let platform: string;
  if (isAndroid) {
    platform = 'android';
  } else if (isIos) {
    platform = 'ios';
  } else {
    platform = 'web';
  }

  return platform;
};

export const getUrlForPlatform = (app: AppSwitcherLink, category: string) => {
  if (category?.toLowerCase() === 'web') {
    return app.url;
  }

  return getCurrentPlatform() === 'android' ? app.urlAndroid : app.urlIos;
};

export const getDesignSystemIconWithFallback = (icon: string) => {
  const DESIGN_SYSTEM_PATH = process.env.NEXT_PUBLIC_DESIGN_SYSTEM_PATH;

  if (!DESIGN_SYSTEM_PATH) {
    return `https://app.stihl.com/designsystem/images/icons/${icon}`;
  }

  return `${DESIGN_SYSTEM_PATH}/images/icons/${icon}`;
};

const INTERNAL_URL_PATTERNS = process.env.NEXT_PUBLIC_FRONTEND_URL_PATTERN?.split(' ') ?? [];

export const isInternalLink = (url: string): boolean => {
  if (!url) return false;
  return INTERNAL_URL_PATTERNS.some((pattern) => {
    return !!new RegExp(pattern).exec(url);
  });
};

export const getRelativeUrl = (url?: string): string => {
  if (!url) return '/';
  if (!isInternalLink(url)) return url.toLowerCase();

  try {
    const { pathname, search, hash } = new URL(url);
    return `${pathname}${search}${hash}`.toLowerCase();
  } catch {
    return url.toLowerCase();
  }
};
